import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useStyles } from './styles';

interface ChipListProps {
  list: (string | undefined)[] | undefined;
  style?: React.CSSProperties;
}

const ChipList = ({ list, style }: ChipListProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.chipWrapper} style={style}>
      {list?.filter(Boolean).map((item) => (
        <Typography key={item} className={classes.chip}>
          {item}
        </Typography>
      ))}
    </Box>
  );
};

export default ChipList;
